<template lang='pug'>
  v-toolbar-items.ml-4.hidden-sm-and-down
    v-menu(v-if= "username" offset-y offset-x right min-width="200")
      v-btn(slot='activator' flat)
        span.user {{ username }}
        v-icon(small) arrow_drop_down
        liondesk-avatar.ml-1(
          :color="userInitials | generateRandomColor('dark')"
          :text="userInitials"
          text-classes="white--text subheading"
          size="38px"
        )
      v-list
        v-list-tile(href="/profile")
          v-list-tile-title Profile
        v-list-tile(href="/settings")
          v-list-tile-title Settings
        v-list-tile(v-if="showSubscriptionSettings" href="https://accounts.liondesk.com/settings")
          v-list-tile-title Payments &amp; Subscription
        v-list-tile(@click='logout')
          v-list-tile-title Logout
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LiondeskAvatar from '@/Core/components/LiondeskAvatar';
import generateRandomColor from '@/Core/utilities/randomColorGenerator';

export default {
  components: {
    LiondeskAvatar,
  },
  props: {
    showSubscriptionSettings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      helpLink: 'https://liondeskv2.helprace.com/',
    };
  },
  filters: {
    generateRandomColor,
  },
  computed: {
    ...mapState({
      user: state => state.userInformation.user,
    }),
    username() {
      if (this.user) {
        return this.user.first_name || this.user.username;
      }
      return null;
    },
    userInitials() {
      if (this.user) {
        const firstLetter = this.user.first_name ? this.user.first_name.slice(0, 1) : '';
        const lastLetter = this.user.last_name ? this.user.last_name.slice(0, 1) : '';
        return firstLetter || lastLetter ? `${firstLetter}${lastLetter}` : 'LD';
      }
      return '';
    },
  },
  methods: {
    async logout() {
      await this.logoutUser();
      // eslint-disable-next-line
      location.reload(); // TODO MW - Come up with a better solution to reset vuex store
    },
    ...mapActions({
      logoutUser: 'authentication/logout',
    }),
  },
};

</script>
<style scoped>
  .user {
    text-transform: initial;
  }
</style>
